import { withStatusOrder } from './utils';

export const OPTHL01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट शुरू की गई',
        kn: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ',
        ta: 'அறைகூவல் தொடங்கப்பட்டது',
        te: 'చాట్ ప్రారంభించబడింది',
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'जांच निर्माण लंबित',
        kn: 'ವಿಚಾರಣೆಯ ರಚನೆ ಬಾಕಿಯಿದೆ',
        ta: 'விசாரணை உருவாக்கம் நிலுவையிலுள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది',
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह प्राप्त कर लिया है। प्रवाह सबमिशन की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಪ್ರವಾಹವನ್ನು ಪಡೆದಿದ್ದಾನೆ. ಪ್ರವಾಹ ಸಲ್ಲಿಕೆಗೆ ನಿರೀಕ್ಷಿಸಲಾಗಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் புலத்தை பெற்றுள்ளார். புலம் சமர்ப்பிக்க காத்திருக்கிறது',
        te: 'కస్టమర్ వాట్సాప్ ఫ్లోని స్వీకరించారు. ఫ్లో సమర్పణ కోసం వేచి ఉంది',
    },
};

export const OPTHL02 = {
    header: {
        en: 'Enquiry Created',
        hi: 'जांच बनाई गई',
        kn: 'ವಿಚಾರಣೆ ರಚಿಸಲಾಗಿದೆ',
        ta: 'விசாரணை உருவாக்கப்பட்டது',
        te: 'విచారణ రూపొందించబడింది',
    },
    label: {
        en: 'Income Details Pending',
        hi: 'आय विवरण लंबित',
        kn: 'ಆದಾಯದ ವಿವರ ಬಾಕಿಯಿದೆ',
        ta: 'வருமான விவரங்கள் நிலுவையிலுள்ளது',
        te: 'ఆదాయ వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 2,
    color: 'info',
    description: {
        en: 'The customer has submitted the WhatsApp flow',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह जमा कर दिया है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಪ್ರವಾಹವನ್ನು ಸಲ್ಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் புலத்தை சமர்ப்பித்துள்ளார்',
        te: 'కస్టమర్ వాట్సాప్ ఫ్లోని సమర్పించారు',
    },
};

export const OPTHL03 = {
    header: {
        en: 'Income Details',
        hi: 'आय विवरण',
        kn: 'ಆದಾಯದ ವಿವರಗಳು',
        ta: 'வருமான விவரங்கள்',
        te: 'ఆదాయ వివరాలు',
    },
    label: {
        en: 'Property Details Pending',
        hi: 'संपत्ति विवरण लंबित',
        kn: 'ಸಂಪತ್ತಿ ವಿವರ ಬಾಕಿಯಿದೆ',
        ta: 'சொத்து விவரங்கள் நிலுவையிலுள்ளது',
        te: 'ప్రాపర్టీ వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 3,
    color: 'info',
    description: {
        en: 'The customer has filled the income and expense details',
        hi: 'ग्राहक ने आय और व्यय विवरण भरा है',
        kn: 'ಗ್ರಾಹಕನು ಆದಾಯ ಮತ್ತು ವೆಚ್ಚದ ವಿವರಗಳನ್ನು ಭರ್ತಿಮಾಡಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் வருவாய் மற்றும் செலவு விவரங்களை பூர்த்தி செய்துள்ளார்',
        te: 'కస్టమర్ ఆదాయ మరియు ఖర్చుల వివరాలను పూర్తి చేశాడు',
    },
};

export const OPTHL04 = {
    header: {
        en: 'Property Details',
        hi: 'संपत्ति विवरण',
        kn: 'ಸಂಪತ್ತಿ ವಿವರಗಳು',
        ta: 'சொத்து விவரங்கள்',
        te: 'ప్రాపర్టీ వివరాలు',
    },
    label: {
        en: 'Property Location Pending',
        hi: 'संपत्ति स्थान लंबित',
        kn: 'ಸಂಪತ್ತಿ ಸ್ಥಳ ಬಾಕಿಯಿದೆ',
        ta: 'சொத்து இருப்பிடம் நிலுவையிலுள்ளது',
        te: 'ప్రాపర్టీ లోకేషన్ పెండింగ్‌లో ఉంది',
    },
    order: 4,
    color: 'info',
    description: {
        en: 'The customer has filled the collateral property details',
        hi: 'ग्राहक ने संपार्श्विक संपत्ति विवरण भरा है',
        kn: 'ಗ್ರಾಹಕನು ಜಾಮೀನು ಆಸ್ತಿ ವಿವರಗಳನ್ನು ಭರ್ತಿಮಾಡಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் அடமான சொத்து விவரங்களை பூர்த்தி செய்துள்ளார்',
        te: 'కస్టమర్ కాలేటరల్ ప్రాపర్టీ వివరాలను పూర్తి చేశాడు',
    },
};

export const OPTHL05 = {
    header: {
        en: 'Property Location',
        hi: 'संपत्ति स्थान',
        kn: 'ಸಂಪತ್ತಿ ಸ್ಥಳ',
        ta: 'சொத்து இருப்பிடம்',
        te: 'ప్రాపర్టీ లోకేషన్',
    },
    label: {
        en: 'Aadhar Verification Pending',
        hi: 'आधार सत्यापन लंबित',
        kn: 'ಆಧಾರ್ ದೃಢೀಕರಣ ಬಾಕಿಯಿದೆ',
        ta: 'ஆதார் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'ఆధార్ ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 5,
    color: 'info',
    description: {
        en: 'The customer has verified their Aadhaar',
        hi: 'ग्राहक ने अपना आधार सत्यापित किया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಆಧಾರ್ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது ஆதாரத்தை சரிபார்த்துள்ளார்',
        te: 'కస్టమర్ తన ఆధార్‌ను ధృవీకరించారు',
    },
};

export const OPTHL06 = {
    header: {
        en: 'Aadhaar Verified',
        hi: 'आधार सत्यापित',
        kn: 'ಆಧಾರ್ ದೃಢೀಕರಿಸಲಾಗಿದೆ',
        ta: 'ஆதார் சரிபார்க்கப்பட்டது',
        te: 'ఆధార్ ధృవీకరించబడింది',
    },
    label: {
        en: 'PAN Verification Pending',
        hi: 'पैन सत्यापन लंबित',
        kn: 'ಪಾನ್ ದೃಢೀಕರಣ ಬಾಕಿಯಿದೆ',
        ta: 'பான் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'పాన్ ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 6,
    color: 'info',
    description: {
        en: 'The customer has verified their Aadhaar',
        hi: 'ग्राहक ने अपना आधार सत्यापित किया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಆಧಾರ್ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது ஆதாரத்தை சரிபார்த்துள்ளார்',
        te: 'కస్టమర్ తన ఆధార్‌ను ధృవీకరించారు',
    },
};

export const OPTHL07 = {
    header: {
        en: 'PAN Verified',
        hi: 'पैन सत्यापित',
        kn: 'ಪಾನ್ ದೃಢೀಕರಿಸಲಾಗಿದೆ',
        ta: 'பான் சரிபார்க்கப்பட்டது',
        te: 'పాన్ ధృవీకరించబడింది',
    },
    label: {
        en: 'Application Submitted',
        hi: 'आवेदन जमा किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    order: 7,
    color: 'info',
    description: {
        en: 'The customer has verified their PAN',
        hi: 'ग्राहक ने अपना पैन सत्यापित किया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಪಾನ್ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது பானை சரிபார்த்துள்ளார்',
        te: 'కస్టమర్ తన పాన్‌ను ధృవీకరించారు',
    },
};

export const OPTHL08 = {
    header: {
        en: 'Application Submitted',
        hi: 'आवेदन प्रस्तुत किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    label: {
        en: 'Awaiting Decision',
        hi: 'निर्णय का इंतजार है',
        kn: 'ನಿರ್ಧಾರದಿಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
        ta: 'தீர்மானத்திற்கு காத்திருக்கிறது',
        te: 'నిర్ణయానికి వేచి ఉంది',
    },
    order: 8,
    color: 'success',
    description: {
        en: 'The customer has submitted their application',
        hi: 'ग्राहक ने अपना आवेदन प्रस्तुत किया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಿದನು',
        ta: 'வாடிக்கையாளர் தனது விண்ணப்பத்தை சமர்ப்பித்துள்ளார்',
        te: 'కస్టమర్ తన అప్లికేషన్‌ను సమర్పించాడు',
    },
};

export const OPTHL09 = {
    header: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯು ತಿರಸ್ಕೃತವಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'అప్లికేషన్ తిరస్కరించబడింది',
    },
    label: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯು ತಿರಸ್ಕೃತವಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'అప్లికేషన్ తిరస్కరించబడింది',
    },
    order: 9,
    color: 'error',
    description: {
        en: 'The loan application has been rejected',
        hi: 'ऋण आवेदन अस्वीकृत कर दिया गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'రుణం అప్లికేషన్ తిరస్కరించబడింది',
    },
};

export const OPTHL10 = {
    header: {
        en: 'Application Approved',
        hi: 'आवेदन स्वीकृत',
        kn: 'ಅರ್ಜಿಯು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'అప్లికేషన్ ఆమోదించబడింది',
    },
    label: {
        en: 'Awaiting Confirmation',
        hi: 'पुष्टि का इंतजार है',
        kn: 'ದೃಢೀಕರಣಕ್ಕಾಗಿ ಕಾಯುತ್ತಿದೆ',
        ta: 'உறுதிப்படுத்தல் காத்திருக்கிறது',
        te: 'నిర్ధారణ కోసం వేచి ఉంది',
    },
    order: 10,
    color: 'success',
    description: {
        en: 'The loan application has been approved',
        hi: 'ऋण आवेदन को स्वीकृत किया गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'రుణం అప్లికేషన్ ఆమోదించబడింది',
    },
};

export const OPTHL11 = {
    header: {
        en: 'Account Aggregator',
        hi: 'खाता एग्रीगेटर',
        kn: 'ಖಾತೆ ಅಗ್ರಿಗೇಟರ್',
        ta: 'கணக்கு திரட்டி',
        te: 'ఖాతా అగ్రిగేటర్',
    },
    label: {
        en: 'Account Aggregator',
        hi: 'खाता एग्रीगेटर',
        kn: 'ಖಾತೆ ಅಗ್ರಿಗೇಟರ್',
        ta: 'கணக்கு திரட்டி',
        te: 'ఖాతా అగ్రిగేటర్',
    },
    order: 12,
    color: 'info',
    description: {
        en: 'Accounts linked.',
        hi: 'खाते जुड़ गए हैं।',
        kn: 'ಖಾತೆಗಳು ಲಿಂಕ್ ಆಗಿವೆ.',
        ta: 'கணக்குகள் இணைக்கப்பட்டுள்ளன.',
        te: 'ఖాతాలు లింక్ చేయబడ్డాయి.',
    },
};

export const OPTHL12 = {
    header: {
        en: 'Digio KYC',
        hi: 'डिजियो केवाईसी',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ',
        ta: 'டிஜியோ கேஒய்சி',
        te: 'డిజియో కేవైసీ',
    },
    label: {
        en: 'Digio KYC',
        hi: 'डिजियो केवाईसी',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ',
        ta: 'டிஜியோ கேஒய்சி',
        te: 'డిజియో కேవైసీ',
    },
    order: 11,
    color: 'info',
    description: {
        en: 'The customer has verified their KYC.',
        hi: 'ग्राहक ने अपना केवाईसी सत्यापित किया है।',
        kn: 'ಗ್ರಾಹಕ ತಮ್ಮ ಕೆವೈಸಿ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது கேஒய்சியை சரிபார்த்துள்ளார்.',
        te: 'కస్టమర్ తన కేవైసీని ధృవీకరించాడు.',
    },
};

export const SHLActiveCases = withStatusOrder({
    OPTHL01,
    OPTHL02,
    OPTHL03,
    OPTHL04,
    OPTHL05,
    OPTHL06,
    OPTHL07,
    OPTHL12,
    OPTHL11,
});

export const SHLContinueJourneyCases = withStatusOrder({
    OPTHL02,
    OPTHL03,
    OPTHL04,
    OPTHL05,
    OPTHL06,
    OPTHL07,
    OPTHL12,
    OPTHL11,
});

export const SHLSanction = withStatusOrder({
    OPTHL08,
});

export const SHLRejected = withStatusOrder({
    OPTHL01,
    OPTHL02,
    OPTHL03,
    OPTHL04,
    OPTHL05,
    OPTHL06,
    OPTHL07,
    OPTHL12,
    OPTHL11,
    // OPTHL09,
});


export const SHLCancelled = withStatusOrder({
    OPTHL01,
    OPTHL02,
    OPTHL03,
    OPTHL04,
    OPTHL05,
    OPTHL06,
    OPTHL07,
    OPTHL12,
    OPTHL11,
})


const OPTHL02_Unserviceable = {
    ...OPTHL02,
    header: {
        ...OPTHL02.header,
        en: 'Unserviceable',
    }
}


export const SHLUnserviceable = withStatusOrder({
    OPTHL02: OPTHL02_Unserviceable,
})

export const getSHLAll = (currentStatusCode) => {
    let SHLAll = {
        OPTHL01,
        OPTHL02,
        OPTHL03,
        OPTHL04,
        OPTHL05,
        OPTHL06,
        OPTHL07,
        OPTHL11,
        OPTHL12,
        OPTHL08,
    };

    if (currentStatusCode === 'OPTHL09') {
        SHLAll = {
            ...SHLAll,
            OPTHL09,
        }
    } else if (currentStatusCode === 'OPTHL10') {
        SHLAll = {
            ...SHLAll,
            OPTHL10,
        }
    } else {
        SHLAll = {
            ...SHLAll,
            OPTHLXX: {
                header: {
                    en: 'Awaiting Decision',
                    hi: 'फैसले का इंतजार',
                    kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
                    ta: 'முடிவிற்காக காத்திருக்கிறது',
                    te: 'నిర్ణయం కోసం వేచి ఉంది',
                },
                color: 'success',
            },
        }
    }

    return withStatusOrder(SHLAll);
};
